import { ApiResponse } from "@/models/api.model";
import { Timeline } from "@/models/timeline.model";
import { PaginationResponse } from "./../models/pagination.model";
import axios from "./axios";

export default {
  getTimeline(page: number) {
    return axios.get().get<ApiResponse<PaginationResponse<Timeline>>>("/timeline", { params: { page } });
  }
};
